import { ControllerRenderProps, FieldValues } from 'react-hook-form'

interface Props {
  config?: any
  field: ControllerRenderProps<FieldValues, string>
  ocField: any
}

export function parseComponentConfig({ config, field, ocField }: Props) {
  const {
    formPropMap = {},
    configPropMap = {},
    propValues = {},
    component,
  } = config

  const Component = component

  const props: Record<string, any> = {}

  for (const key in formPropMap) {
    props[key] = field?.[formPropMap[key]]
  }

  for (const key in configPropMap) {
    props[key] = ocField[configPropMap[key]]
  }

  for (const key in propValues) {
    const value = propValues[key]
    props[key] = value
  }
  props.isRequired = ocField?.config?.required
  props.infoMsg = ocField?.config?.infoMsg
  props.toggleType = ocField?.config?.toggleType
  props.config = ocField?.config
  props.isAmount = ocField?.isAmount

  return { Component, componentProps: props }
}
